import React, { useEffect, useState } from 'react';
import './MakeupTutorials.css';
import { getTutorialVideos } from '../../services/galleryService';

const MakeupTutorials = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    getTutorialVideos().then(setVideos);
  }, []);

  // Helper to extract ID from any YouTube link
  const extractYouTubeID = (url) => {
    if (url.includes('/shorts/')) {
      return url.split('/shorts/')[1]?.split('?')[0];
    } else if (url.includes('v=')) {
      return url.split('v=')[1]?.split('&')[0];
    } else {
      return url.split('/').pop();
    }
  };

  return (
    <div className="tutorials-page">
      <div className="top-heading">
        <h1>MAKEUP TUTORIALS</h1>
      </div>

      <div className="tutorials-grid">
        {videos.map((video, index) => {
          const videoId = extractYouTubeID(video.link);
          return (
            <div key={index} className="tutorial-card fade-in">
              <div className="video-wrapper">
                <iframe
                  src={`https://www.youtube.com/embed/${videoId}`}
                  frameBorder="0"
                  allowFullScreen
                  title={video.title}
                ></iframe>
              </div>
              <h3>{video.title}</h3>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MakeupTutorials;
